// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sDwc","name":"styles_name__1L_PM","phone":"styles_phone__wesvf"};